const CHECKBOX = 'checkbox';
const LIST_ICON = 'list-icon';
const LIST_SIMPLE = 'list';

const TODAY = 'today';
const END_TODAY = 'end_today';
const THIS_MONTH = 'this_month';
const THIS_YEAR = 'this_year';
const LAST_YEAR = 'last_year';
const LAST_YEAR_END = 'last_year_end';

const FORMAT = 'YYYY-MM-DD';
const DAYJS_HUMAN_READABLE_FORMAT = 'DD MMM YYYY';
const ISO_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

const PRIMARY_BLUE = '#027aff';
const LIGHT_GRAY = '#eee';
const TEXT_GRAY = '#999999';

const VARIANT_LARGE = 'Large';
const VARIANT_MEDIUM = 'Medium';
const VARIANT_SMALL = 'Small';
const VARIANT_SMALL_HEADER = 'Small-Header';
const VARIANT_XS = 'XS';

const RED = 'red';
const BLUE = 'blue';
const GREEN = 'green';
const ORANGE = 'orange';
const YELLOW = 'yellow';
const PINK = 'pink';

const GLOBAL = 'Global';
const CONNECTED = 'Connected';
const LOCAL = 'Local';

const METERS = 'M';
const KILOMETERS = 'KM';
const SECONDS = 'SEC';
const HOURS = 'HRS';
const HOUR = 'HR';
const DAYS = 'DAYS';
const MINUTES = 'MINS';

export const MEASUREMENT_UNITS = {
    METERS,
    KILOMETERS,
    SECONDS,
    HOURS,
    HOUR,
    DAYS,
    MINUTES,
};

export const CHALLENGE_TYPES = {
    GLOBAL,
    CONNECTED,
    LOCAL,
};

export const RADIO_COLORS = [RED, BLUE, GREEN, ORANGE, YELLOW, PINK];

export const placeholderAvatar =
    'https://i.ebayimg.com/images/g/JV8AAOSwImRYHAqF/s-l300.jpg';

export const PICTURE_VARIANTS = {
    VARIANT_LARGE,
    VARIANT_MEDIUM,
    VARIANT_SMALL,
    VARIANT_SMALL_HEADER,
    VARIANT_XS,
};

const CATEGORY = 'category';
const MATERIAL = 'material';
const OBJECT = 'object';
const BRAND = 'brand';

export const DROPDOWN_VARIANTS = {
    CHECKBOX,
    LIST_ICON,
    LIST_SIMPLE,
};

export const THEME = {
    PRIMARY_BLUE,
    LIGHT_GRAY,
    TEXT_GRAY,
};

export const PERIOD = {
    TODAY,
    END_TODAY,
    THIS_MONTH,
    THIS_YEAR,
    LAST_YEAR,
    LAST_YEAR_END,
    FORMAT,
    ISO_FORMAT,
    DAYJS_HUMAN_READABLE_FORMAT,
};

export const TAXONOMY = {
    CATEGORY,
    MATERIAL,
    BRAND,
    OBJECT,
};

export const TAXONOMY_DROPDOWN = [
    {
        key: TAXONOMY.CATEGORY,
        label: 'Category',
        id: 2,
        icon: 'icon-profile-icon',
    },
    {
        key: TAXONOMY.OBJECT,
        label: 'Object',
        id: 3,
        icon: 'icon-power-icon',
    },
    {
        key: TAXONOMY.MATERIAL,
        label: 'Material',
        id: 4,
        icon: 'icon-settings-icon',
    },
    {
        key: TAXONOMY.BRAND,
        label: 'Brand',
        id: 4,
        icon: 'icon-power-icon',
    },
];

export const DROPDOWNDATA = [
    {
        key: PERIOD.THIS_MONTH,
        label: 'This Month',
        id: 1,
    },
    {
        key: PERIOD.TODAY,
        label: 'Today',
        id: 2,
    },
    {
        key: PERIOD.THIS_YEAR,
        label: 'This Year',
        id: 3,
    },
    {
        key: PERIOD.LAST_YEAR,
        label: 'Last Year',
        id: 3,
    },
];

export const CHART_COLOURS = {
    BLUE: [
        '#027aff',
        '#1b87ff',
        '#3595ff',
        '#4ea2ff',
        '#67afff',
        '#81bdff',
        '#9acaff',
        '#b3d7ff',
        '#cce4ff',
        '#e6f2ff',
    ],
    ORANGE: [
        '#ffa403',
        '#ffad1c',
        '#ffb635',
        '#ffbf4f',
        '#ffc868',
        '#ffd281',
        '#ffdb9a',
        '#ffe4b3',
        '#ffedcd',
        '#fff6e6',
    ],
};

export default Object.freeze({
    DROPDOWN_VARIANTS,
    TAXONOMY_DROPDOWN,
    PICTURE_VARIANTS,
    CHART_COLOURS,
    THEME,
    PERIOD,
    TAXONOMY,
    RADIO_COLORS,
    DROPDOWNDATA,
    MEASUREMENT_UNITS,
});
